import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { RuleListPageModule } from "@comunicare/comunicare-rule-list";
import { TranslateModule } from "@ngx-translate/core";
import { RuleListContainerPageComponent } from "./rule-list-container-page.component";

@NgModule({
  declarations: [RuleListContainerPageComponent],
  imports: [
    CommonModule,
    TranslateModule,
    RuleListPageModule,
    RouterModule.forChild([{ path: "", component: RuleListContainerPageComponent }]),
  ],
  exports: [RuleListContainerPageComponent],
})
export class RuleListContainerPageModule {}
